import React from 'react'
import { Grid } from 'semantic-ui-react'
import { FormTitle } from '@commonComponents/FormTitle'
import ValueIndicatorForm from '@EUForms/invoice/ValueIndicatorForm'
import { useSelector } from 'react-redux'

const ValueIndicator = ({invoiceId,merchandiseId}) => {
  const partyDependency =
    useSelector((state) => {
      return state.ValueBuildUpReducer.shipmentInvoice
        .find((c) => c.invoiceId === invoiceId)
        ?.merchandise?.find((a) => a.merchandiseId === merchandiseId)
    })?.partyDependency?.split(',') || []
  return (
    <Grid className='responsiveGridCss'>
      <FormTitle
        title='VALUE INDICATORS'
        boxNumber={'4/13'}
        containerStyle={{ width: '100%' }}
      ></FormTitle>
      <ValueIndicatorForm partyDependency={partyDependency} />
    </Grid>
  )
}

export default React.memo(ValueIndicator)
